import { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router";
import { connect, RootStateOrAny } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import moment from "moment";
import _, { debounce } from "lodash";

import {
  Select,
  Input,
  Radio,
  Button,
  TimePicker,
  AutoComplete,
  Table,
  Modal,
  Form,
  Alert,
  Spin,
  Space,
  Divider,
} from "antd";
import Title from "antd/lib/typography/Title";
import {
  CloseOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";

import { ErrorResponse } from "utils/types";
import notifier from "utils/notifier";
import { toLetters, validateCharges } from "utils/helpers";
import { states } from "utils/objects";
import { ResubCodes } from "utils/enums";

import { create } from "store/claim/actions";
import {
  getProviderNPI,
  checkIsDME,
  validateRendering,
  verify,
  getOther,
  getName as getNameFromNpi,
} from "store/claim/npi/actions";
import { getVendors } from "store/app/actions";
import { getAuthModifierCode } from "store/authorization/modifierCode/actions";
import { getPos } from "store/authorization/pos/actions";
import { checkMediCalCode } from "store/authorization/mediCal/actions";
import { getDiagCodes } from "store/authorization/diagCodes/actions";
import { get as getCPTCodes, searchByType } from "store/claim/cptCodes/actions";
import { getAuthDetail } from "store/claim/member/actions";
import {
  checkCPTCompatibility,
  getRelated,
  getNdcCodes,
  checkIfNdcIsRequired,
} from "store/claim/ndc/actions";
import {
  getFacilities,
  getClaimsFacilities,
  IClaimsFacilities,
  IFacilities,
} from "store/authorization/facilities/actions";
import {
  uploadAttachment,
  getInvalidPrimDxInitials,
} from "store/claim/actions";

import FloatLabel from "components/Common/FloatLabel";
import LoadingIndicator from "components/Common/LoadingIndicator";
import DropzoneLocal from "components/Common/Dropzone";
import DatePickerLocalised from "components/Common/DatePickerLocalised";

import constants from "constants/index";
import PatientInfo from "./PatientInfo";
import {
  EMCodeSelectionModal,
  OtherProviderModal,
  RelatedNdcModal,
} from "./Modals";
import { ProcedureTable } from "./Tables";
import { ClaimInfoProps, DiagInfo, ProcInfo } from "./Proptypes";
import {
  AMBULATORY_CODES,
  EM_EXCLUSION_CODES,
  G_CODES,
  HOSPITALIZATION_REQUIRED_POS_CODE,
} from "./Codes";
import { validateNDC } from "./Validators";

import "./index.scss";

const { Option } = Select;
const { confirm } = Modal;

// TODO:
// CheckisDME
// SL Modifier

const ClaimInfo = (props: ClaimInfoProps) => {
  const history = useHistory();
  const [form] = Form.useForm();
  const [attachmentList, setAttachmentList] = useState<any[]>([]);

  // Dates
  const [currentDate, setCurrentDate] = useState("");
  const [otherDate, setOtherDate] = useState("");
  const [hospitalFrom, setHospitalFrom] = useState("");
  const [hospitalTo, setHospitalTo] = useState("");
  const [unavailableFrom, setUnavailableFrom] = useState("");
  const [unavailableTo, setUnavailableTo] = useState("");
  const [dosFrom, setDosFrom] = useState("");
  const [dosTo, setDosTo] = useState("");

  //NPI info
  const [npi, setNpi] = useState("");
  const [referringProvider, setReferringProvider] = useState("");
  const [resubCode, setResubCode] = useState("");

  // procedure info
  const [procedure, setProcedure] = useState("NDC");
  const [cpt, setCPT] = useState<any>({});
  const [pos, setPOS] = useState("");
  const [posOffice, setPosOffice] = useState(true);
  const [additionalDiags, setAdditionalDiags] = useState<any>({});

  // API Results
  const [diagCodeResult, setDiagCodeResult] = useState<any[]>([]);
  const [ndcCodeResult, setNdcCodeResult] = useState<any[]>([]);
  const [diagDataSource, setDiagDataSource] = useState<any[]>([]);
  const [CPTCodesResult, setCPTCodesResult] = useState<any[]>([]);
  const [modifierCodes, setModifierCodes] = useState<any[]>([]);
  const [procDataSource, setProcDataSource] = useState<any[]>([]);
  const [vendors, setVendors] = useState<any[]>([]);
  const [posList, setPosList] = useState<any[]>([]);
  const [otherProviders, setOtherProviders] = useState<any[]>([]);
  const [ndcRequired, setNdcRequired] = useState(false);
  const [patientAccount, setPatientAccount] = useState("");
  const [amountPaid, setAmountPaid] = useState("0");
  const [totalCharges, setTotalCharges] = useState("0");
  const [balance, setBalance] = useState("0");
  const [facilities, setFacilities] = useState<any[]>([]);
  const [selectedFacility, setSelectedFacility] = useState<any>({});
  const [EMCodes, setEMCodes] = useState<any[]>([]);
  const [measureCodes, setMeasureCodes] = useState<any[]>([]);
  const [mediCalCheck, setMediCalCheck] = useState(false);

  const [datesVisible, setDatesVisible] = useState(false);
  const [totalTime, setTotalTime] = useState("");
  const [totalTimeInMinutes, setTotalTimeInMinutes] = useState(0);

  const [portalClaimMaster, setPortalClaimMaster] = useState<any>({});
  const [patientInfo, setPatientInfo] = useState<any>({});

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [otherProviderModalVisible, setOtherProviderModalVisible] =
    useState(false);
  const [relatedNdcModalVisible, setRelatedNdcModalVisible] = useState(false);
  const [EMCodeSelectionModalVisible, setEMCodeSelectionModalVisible] =
    useState(false);
  const [selectedEMCode, setSelectedEMCode] = useState("");
  const [sameNPI, setSameNPI] = useState(false);
  const [submitFlag, setSubmitFlag] = useState(false);
  const scrollToRef = useRef<null | HTMLDivElement>(null);

  const [showClaimSubmitted, setShowClaimSubmitted] = useState(false);
  const [missingCPTCode, setMissingCPTCode] = useState(false);
  const [disableCptCode, setDisableCptCode] = useState(false);
  const [invalidPrimDxInitials, setInvalidPrimDxIntials] = useState<string[]>(
    []
  );
  const [diagErrorMsg, setDiagErrorMsg] = useState("");

  const diagColumns = [
    {
      title: "REMOVE",
      key: "index",
      dataIndex: "index",
      render: (_: string, record: any, index: number) => {
        return (
          record.newICD !== "No" && (
            <>
              <a onClick={() => handleRemoveDiag(index, record)}>
                <DeleteOutlined />
              </a>
            </>
          )
        );
      },
    },
    {
      title: "DIAG REF",
      key: "Index",
      dataIndex: "index",
      render: (_: any, __: any, index: any) => toLetters(index + 1),
    },
    {
      title: "DIAGNOSIS CODE",
      key: "RmiDiagCode",
      dataIndex: "RmiDiagCode",
    },
    {
      title: "DESCRIPTION",
      key: "RmiDiagDesc",
      dataIndex: "RmiDiagDesc",
    },
  ];

  useEffect(() => {
    getMeasuresFromPopup2();
    getProviderNPI();
    getPOS();
    getAuthModifierCodes();
    getVendors();
    getCPTByType(
      "CPT.EvaluationAndManagement,CPT.PreventiveMedicineServices,CPT.GCodes",
      setEMCodes
    );
    getCPTByType("CPT.CatII", setMeasureCodes);
    checkMediCalCode();
    getInvalidPrimDxInitials();

    setDosFrom(props.dos);
    setDosTo(props.dos);
  }, []);

  useEffect(() => {
    if (pos) {
      getFacilities(pos);
    }
  }, [pos])

  useEffect(() => {
    if (cpt.RmiProcCode) form.validateFields(["ndcCode"]);
  }, [cpt]);

  useEffect(() => {
    form.validateFields([
      "hospitalFrom",
      "hospitalTo",
      "procedureFrom",
      "procedureTo",
      "unavailableFrom",
      "unavailableTo",
      "npi",
      "provider",
      "priorAuthNo",
    ]);
  }, [
    hospitalFrom,
    hospitalTo,
    dosFrom,
    dosTo,
    unavailableFrom,
    unavailableTo,
    procDataSource,
    npi,
    referringProvider,
    resubCode,
  ]);

  const getMeasuresFromPopup2 = () => {
    //props.measures is coming from useLocation on the FinalSubmission container page
    setPortalClaimMaster(props.measures.portalClaimMaster);

    setProcDataSource(
      props.measures.portalClaimDetails.map((portalClaimDetail: any) => ({
        ...portalClaimDetail,
        newMeasure: "No",
      }))
    );

    setDiagDataSource(
      props.measures.portalClaimDiags.map((portalClaimDiag: any) => ({
        ...portalClaimDiag,
        newICD: "No",
      }))
    );

    setMissingCPTCode(
      props.measures.portalClaimDetails.filter((proc: any) => !proc.RmiCptCode)
        .length > 0
    );

    form.setFields([
      {
        name: "vendorNPI",
        value: props.measures.portalClaimMaster.RmiBillingProviderNpi,
      },
      {
        name: "vendorName",
        value: props.measures.portalClaimMaster.RmiBillingProviderName,
      },
      {
        name: "vendorAddress",
        value: props.measures.portalClaimMaster.RmiBillingProviderAddress,
      },
      {
        name: "vendorCity",
        value: props.measures.portalClaimMaster.RmiBillingProviderCity,
      },
      {
        name: "vendorState",
        value: props.measures.portalClaimMaster.RmiBillingProviderState,
      },
      {
        name: "vendorZip",
        value: props.measures.portalClaimMaster.RmiBillingProviderZip,
      },
      {
        name: "vendorPhone",
        value: props.measures.portalClaimMaster.RmiBillingProviderPhone,
      },
    ]);
  };

  const checkMediCalCode = () => {
    return props
      .checkMediCalCode(props.memberInfo.RmiHpCode)
      .then((response: boolean) => {
        setMediCalCheck(response);
      })
      .catch((err: ErrorResponse) => {
        notifier.error(
          err?.response?.data?.Message ||
            "Something went wrong, please contact a system administrator."
        );
      });
  };

  const getInvalidPrimDxInitials = () => {
    return props
      .getInvalidPrimDxInitials(props.memberInfo.RmiCompanyId)
      .then((response: string[]) => {
        setInvalidPrimDxIntials(response);
      })
      .catch((err: ErrorResponse) => {
        notifier.error(
          err?.response?.data?.Message ||
            "Something went wrong, please contact a system administrator."
        );
      });
  };

  const getProviderNPI = () => {
    return props
      .getProviderNPI(
        props.memberInfo.RmiProvKeyId,
        props.memberInfo.RmiCompanyId
      )
      .then((response: string) => {
        response
          ? form.setFieldsValue({ renderingProvider: response.trim() })
          : getOtherProviderNPI();
      })
      .catch((err: ErrorResponse) => {
        notifier.error(
          err?.response?.data?.Message ||
            "Something went wrong, please contact a system administrator."
        );
      });
  };

  const getOtherProviderNPI = () => {
    return props
      .getOther(props.memberInfo.RmiProvKeyId, props.memberInfo.RmiCompanyId)
      .then((response: any[]) => {
        if (response.length !== 0) {
          setOtherProviderModalVisible(true);
          setOtherProviders(response);
        }
      })
      .catch((err: ErrorResponse) => {
        notifier.error(
          err?.response?.data?.Message ||
            "Something went wrong, please contact a system administrator."
        );
      });
  };

  const getPOS = () => {
    return props
      .getPos(props.memberInfo.RmiCompanyId)
      .then((response: any[]) => {
        response.map((item) => {
          if (item.RmiCode === "11") {
            setPOS(item.Code);
            form.setFieldsValue({ pos: JSON.stringify(item) });
          }
        });
        setPosList(response);
      })
      .catch((err: ErrorResponse) => {
        notifier.error(
          err?.response?.data?.Message ||
            "Something went wrong, please contact a system administrator."
        );
      });
  };

  const getAuthModifierCodes = () => {
    props
      .getAuthModifierCode()
      .then((response: any[]) => {
        setModifierCodes(response);
      })
      .catch((err: any) => {
        notifier.error(
          err?.response?.data?.Message ||
            "Something went wrong, please contact a system administrator."
        );
      });
  };

  const getVendors = () => {
    return props
      .getVendors(props.memberInfo.RmiProvKeyId, props.memberInfo.RmiCompanyId)
      .then((response: any[]) => {
        setVendors(response);
      })
      .catch((err: ErrorResponse) => {
        notifier.error(
          err?.response?.data?.Message ||
            "Something went wrong, please contact a system administrator."
        );
      });
  };

  const verifyNPI = (npi: string) => {
    return props
      .verify(npi)
      .then((response: boolean) => {
        return response;
      })
      .catch((err: any) => {
        notifier.error(
          err?.response?.data?.Message ||
            "Something went wrong, please contact a system administrator."
        );
      });
  };

  const getAuthDetail = (authNo: string) => {
    return props
      .getAuthDetail(
        props.memberInfo.RmiMembKeyId,
        props.memberInfo.RmiProvKeyId,
        authNo
      )
      .then((response: any[]) => {
        return response;
      })
      .catch((err: ErrorResponse) => {
        notifier.error(
          err?.response?.data?.Message ||
            "Something went wrong, please contact a system administrator."
        );
      });
  };

  const checkCPTCompatibility = (cpt: string, ndc: string) => {
    return props
      .checkCPTCompatibility(cpt, ndc ? ndc.replace(/\D/g, "") : null)
      .then((response: boolean) => {
        return response;
      })
      .catch((err: ErrorResponse) => {
        notifier.error(
          err?.response?.data?.Message ||
            "Something went wrong, please contact a system administrator."
        );
      });
  };

  const validateRenderingNpi = (npi: string) => {
    return props
      .validateRendering(
        npi,
        props.memberInfo.RmiProvKeyId,
        props.memberInfo.RmiCompanyId
      )
      .then((response: boolean) => {
        return response;
      })
      .catch((err: ErrorResponse) => {
        notifier.error(
          err?.response?.data?.Message ||
            "Something went wrong, please contact a system administrator."
        );
      });
  };

  const getNameFromNpi = (npi: string) => {
    return props
      .getNameFromNpi(npi)
      .then((response: any[]) => {
        return response;
      })
      .catch((err: ErrorResponse) => {
        notifier.error(
          err?.response?.data?.Message ||
            "Something went wrong, please contact a system administrator."
        );
      });
  };

  const getFacilities = (selectedPOS: any) => {
    let searchObject = {
      POS: selectedPOS.RmiCode,
      RmiCompanyId: props.memberInfo.RmiCompanyId,
      SpecialGroupId: "",
    };

    return props
      .getFacilities(searchObject)
      .then((response: any[]) => {
        return response;
      })
      .then((facilities: any[]) => {
        let searchObject = {
          ProvKeyId: props.memberInfo.RmiProvKeyId,
          CompanyId: props.memberInfo.RmiCompanyId,
        };

        return props
          .getClaimsFacilities(searchObject)
          .then((claimFacilities: any) => {
            //default to office type 1 facility
            let defaultFacility: IFacilities = {
              AddressId: null,
              City: null,
              LastName: null,
              Phone: null,
              ProvKeyId: null,
              State: null,
              Street: null,
              Zip: null,
            };

            let npiType2 = "";

            if (claimFacilities?.length > 0) {
              claimFacilities.forEach((facility: any) => {
                const newFacility: IFacilities = {
                  AddressId: facility?.RmiUid,
                  City: facility?.RmiCity,
                  LastName: `${facility?.RmiLastName} ${
                    facility.OfficeType?.match(/\d+/)[0]
                  }`,
                  Phone: facility?.RmiPhone,
                  ProvKeyId: facility?.RmiProvKeyId,
                  State: facility?.RmiState,
                  Street: facility?.RmiStreet,
                  Zip: facility?.RmiZip,
                };

                if (facility.OfficeType === "OFFICE 1") {
                  defaultFacility = newFacility;
                  npiType2 = facility.RmiOutsideId;

                  form.setFieldsValue({
                    facilityNPI: npiType2,
                    facility: JSON.stringify(defaultFacility),
                  });

                  //auto populate default facility if there is office type 1 (latest address)
                  setSelectedFacility(defaultFacility);
                  form.setFields([
                    { name: "facilityName", value: defaultFacility.LastName },
                    { name: "facilityAddress", value: defaultFacility.Street },
                    { name: "facilityCity", value: defaultFacility.City },
                    { name: "facilityState", value: defaultFacility.State },
                    { name: "facilityZip", value: defaultFacility.Zip },
                  ]);

                  form.validateFields([
                    "facility",
                    "facilityName",
                    "facilityAddress",
                    "facilityCity",
                    "facilityState",
                    "facilityZip",
                  ]);

                  facilities.push(newFacility);
                }
              });
            }

            setFacilities(facilities);
          })
          .catch((err: ErrorResponse) => {
            notifier.error(
              err?.response?.data?.Message ||
                "Something went wrong, please contact a system administrator."
            );
          });
      })
      .catch((err: ErrorResponse) => {
        notifier.error(
          err?.response?.data?.Message ||
            "Something went wrong, please contact a system administrator."
        );
      });
  };

  const getCPTByType = (cptType: string, set: Function) => {
    return props
      .searchByType(sessionStorage.getItem("user_id")!, cptType)
      .then((response: any[]) => {
        set(response);
      })
      .catch((err: ErrorResponse) => {
        notifier.error(
          err?.response?.data?.Message ||
            "Something went wrong, please contact a system administrator."
        );
      });
  };

  const calculateTotalTime = () => {
    const start = form.getFieldValue("ndcFrom");
    const end = form.getFieldValue("ndcTo");

    if (!start || !end) {
      setTotalTime(`0 hours 0 minutes`);
      setTotalTimeInMinutes(0);
      return;
    }

    let duration = moment.duration(end.diff(start));
    let hours = duration.hours() > 0 ? duration.hours() : 0;
    let minutes = duration.minutes() > 0 ? duration.minutes() : 0;

    setTotalTime(`${hours} hours ${minutes} minutes`);
    setTotalTimeInMinutes(Math.ceil(duration.asMinutes()));
  };

  const clickOtherProvider = (npi: string) => {
    form.setFieldsValue({ renderingProvider: npi });
    setOtherProviderModalVisible(false);
  };

  const handleDiagCodeSearch = (value: string) => {
    if (value.length < 3) return;
    let searchObject = {
      actionDate: moment().format("MM-DD-YYYY"),
      companyId: props.memberInfo.RmiCompanyId,
      diagCode: value,
      endDate: props.memberInfo.RmiTermDate,
      iCDVersion: constants.ICD_VERSION,
      startDate: props.memberInfo.RmiStartDate,
    };
    props
      .getDiagCodes(searchObject)
      .then((response: any) => {
        setDiagCodeResult(response);
      })
      .catch((err: ErrorResponse) => {
        notifier.error(
          err?.response?.data?.Message ||
            "Something went wrong, please contact a system administrator."
        );
      });
  };

  const handleSelectDiagCode = (value: string, option: any) => {
    let newArr: any[] = [...diagDataSource];
    let diag = JSON.parse(value);
    form.setFieldsValue({ diagnosis: diag.diagcode });

    if (
      diagDataSource.length == 0 &&
      diag.RmiDiagCode !== null &&
      invalidPrimDxInitials.includes(diag.RmiDiagCode[0])
    ) {
      setDiagErrorMsg(
        "Primary diagnosis can not be a diag starting with V, W, X or Y."
      );
      setTimeout(() => {
        setDiagErrorMsg("");
      }, 5000);
      form.setFieldsValue({ diagnosis: "" });
      return;
    }

    // cannot have more than 12 diagnoses on the table
    if (newArr.length >= 12) {
      notifier.error("Cannot have more than 12 diagnoses listed for 1 claim.");
      return;
    }

    if (constants.ICD_VERSION === 10 && diag.RmiSpecificity === false) {
      // throw error
      notifier.error(
        "This code is not billable or specific ICD-10-CM diag code. Please select a more specific diagnosis."
      );
      return;
    }

    for (let i = 0; i < newArr.length; i++) {
      //replaces z00.00 with z00.01
      if (newArr[i].RmiDiagCode === "Z00.00" && diag.RmiDiagCode === "Z00.01") {
        newArr[i] = diag;
        setDiagDataSource(() => {
          form.setFieldsValue({ diagnosis: "" });

          // add to Diagnoses in Procedure Info
          setAdditionalDiags({
            ...diag,
            RmiClaimMasterId: portalClaimMaster.RmiUid,
            RmiCreatedBy: portalClaimMaster.RmiCreatedBy,
            RmiModifiedBy: portalClaimMaster.RmiModifiedBy,
            RmiCreatedDate: moment(),
            RmiModifiedDate: moment(),
            RmiIdx: newArr.length + 1,
            RmiDiagRefLetter: toLetters(newArr.length + 1),
          });
          form.setFieldsValue({ additionalDiags: diag.RmiDiagCode });
          return [...newArr];
        });
        return;
      }

      if (newArr[i].RmiDiagCode === "Z00.01" && diag.RmiDiagCode === "Z00.00") {
        notifier.error("Z00.01 must be removed first before adding in Z00.00.");
        return;
      }
      if (newArr[i].RmiDiagCode === diag.RmiDiagCode) {
        // duplicate
        notifier.error(
          "Duplicate Diagnosis Code exists. Please select a different diagnosis."
        );
        return;
      }
    }

    // Add to table
    setDiagDataSource(() => {
      form.setFieldsValue({ diagnosis: "" });

      // add to Diagnoses in Procedure Info
      setAdditionalDiags({
        ...diag,
        RmiClaimMasterId: portalClaimMaster.RmiUid,
        RmiCreatedBy: portalClaimMaster.RmiCreatedBy,
        RmiModifiedBy: portalClaimMaster.RmiModifiedBy,
        RmiCreatedDate: moment(),
        RmiModifiedDate: moment(),
        RmiIdx: newArr.length + 1,
        RmiDiagRefLetter: toLetters(newArr.length + 1),
      });
      return [
        ...newArr,
        {
          ...diag,
          RmiClaimMasterId: portalClaimMaster.RmiUid,
          RmiCreatedBy: portalClaimMaster.RmiCreatedBy,
          RmiModifiedBy: portalClaimMaster.RmiModifiedBy,
          RmiCreatedDate: moment(),
          RmiModifiedDate: moment(),
          RmiIdx: newArr.length + 1,
          RmiDiagRefLetter: toLetters(newArr.length + 1),
        },
      ];
    });
  };

  const handleRemoveDiag = (index: number, record: any) => {
    if (
      procDataSource.length !== 0 &&
      procDataSource.find((x) => x.diagRef === toLetters(index + 1))
    ) {
      Modal.error({
        title: "Oops!",
        content:
          "There is a service line referring to this diagnosis code. Please remove the service line first.",
      });
    } else {
      var diags = diagDataSource.filter((_, i) => i !== index);

      if (
        diags.length > 0 &&
        diags[0].RmiDiagCode !== null &&
        invalidPrimDxInitials.includes(diags[0].RmiDiagCode[0])
      ) {
        form.setFieldsValue({ diagnosis: "" });
        setDiagErrorMsg(
          "This diagnosis can not be removed as it is immediately followed by diag starting V, W, X or Y."
        );
        setTimeout(() => {
          setDiagErrorMsg("");
        }, 5000);
        return;
      }
      setDiagDataSource((prev) => prev.filter((_, i) => i !== index));
    }
  };

  const handleNdcCodeSearch = (value: string) => {
    if (value.length < 4) return;

    props
      .getNdcCodes(value)
      .then((response: any) => {
        setNdcCodeResult(response);
      })
      .catch((err: ErrorResponse) => {
        notifier.error(
          err?.response?.data?.Message ||
            "Something went wrong, please contact a system administrator."
        );
      });
  };

  const handleSelectNdcCode = (value: string, option: any) => {
    let selectedNdc = JSON.parse(value);
    form.setFieldsValue({ ndcCode: selectedNdc.code });
  };

  const tabSelectEvent = (evt: any, searchResult: any[], id: string) => {
    if (searchResult.length > 0 && evt.key === "Tab") {
      const enterKey = new KeyboardEvent("keydown", {
        code: "Enter",
        key: "Enter",
        charCode: 13,
        keyCode: 13,
        view: window,
        bubbles: true,
      });

      document.getElementById(id)!.dispatchEvent(enterKey);
    }
  };

  const handleCPTCodeSearch = (value: string) => {
    if (value.length < 2) return;

    const phCode =
      !["ALPHA", "CFC"].includes(props.provider.RmiCompanyId) &&
      [
        "21",
        "22",
        "23",
        "24",
        "31",
        "32",
        "33",
        "51",
        "61",
        "62",
        "65",
      ].includes(JSON.parse(form.getFieldValue("pos")).RmiCode)
        ? "H"
        : "P";
    const searchObject = {
      RmiSpecialtyProvKeyId: props.memberInfo.RmiProvKeyId,
      RmiCompanyId: props.memberInfo.RmiCompanyId,
      CPTCode: value,
      RmiEndDate: props.memberInfo.RmiTermDate,
      RmiHpCode: props.memberInfo.RmiHpCode,
      RmiPhCode: phCode,
      RmiStartDate: props.memberInfo.RmiStartDate,
      RmiMembKeyId: props.memberInfo.RmiMembKeyId,
      ICDCode: additionalDiags.RmiDiagCode,
    };
    props
      .getCPTCodes(searchObject)
      .then((response: any[]) => {
        const unique = response.filter(
          (ele: any, ind: number) =>
            ind ===
            response.findIndex(
              (elem: any) => elem.RmiProcCode === ele.RmiProcCode
            )
        );
        setCPTCodesResult(unique);
      })
      .catch((err: ErrorResponse) => {
        notifier.error(
          err?.response?.data?.Message ||
            "Something went wrong, please contact a system administrator."
        );
      });
  };

  const handleCPTCodeSelect = (value: string) => {
    const parsed = JSON.parse(value || "{}");
    setNdcRequired(false);

    // MedicalRX Warning
    if (mediCalCheck && parsed && parsed.MedicalRxExclusion) {
      Modal.error({
        title: "Medi-Cal RX Program",
        content: (
          <>
            Requested services are covered under Medi-Cal Rx Program. <br />
            Please choose one of the external links to submit your request:{" "}
            <br /> <br />
            <a href="https://medi-calrx.dhcs.ca.gov/provider/" target="_blank">
              <b>https://medi-calrx.dhcs.ca.gov/provider/</b>
            </a>
            <br />
            <a href="https://account.covermymeds.com/" target="_blank">
              <b>https://account.covermymeds.com/</b>
            </a>
          </>
        ),
        maskClosable: false,
      });
      form.resetFields([
        "cpt",
        "units",
        "modifier",
        "additionalDiags",
        "additionalAddedDiags",
        "additionalModifiers",
      ]);
      setCPTCodesResult([]);
    } else {
      setNdcRequired(parsed.IsNdcRequired);
      if (
        parsed.ServiceCode?.startsWith("R") ||
        parsed.ServiceCode?.startsWith("P")
      ) {
        setNdcRequired(true);
      }

      setCPT(parsed);
      form.setFieldsValue({ cpt: parsed.ServiceCode });
      form.setFieldsValue({ units: 1 });
      form.setFieldsValue({ ndcCode: "" });
    }
  };

  const validateProcedure = () => {
    // Validate fields
    setIsSubmitting(false);
    form
      .validateFields([
        "diagnosis",
        "procedure",
        "ndcCode",
        "ndcUnit",
        "ndcQty",
        "ndcFrom",
        "ndcTo",
        "procedureFrom",
        "procedureTo",
        "pos",
        "emg",
        "cpt",
        "procedureCharges",
        "units",
        "renderingProvider",
        "modifier",
        "additionalDiags",
        "additionalAddedDiags",
        "additionalModifiers",
        "additionalServiceInfo",
      ])
      .then((values: any) => {
        // check service charge value
        if (values.procedureCharges >= 10000) {
          confirm({
            title: "Are you sure you would like to add this service line?",
            icon: <ExclamationCircleOutlined />,
            content:
              "The charges for this service code equal or exceed $10,000.",
            onOk: () => addToProcTable(values),
            onCancel() {},
          });
        } else {
          addToProcTable(values);
        }
      })
      .catch((err) => {
        notifier.error(
          "Please fix the highlighted fields before adding a Procedure."
        );
      });
  };

  const addToProcTable = (values: any) => {
    // Add to Table
    const row = {
      key: procDataSource.length.toString(),
      RmiAdj: null,
      RmiCharges: values.procedureCharges,
      RmiClaimMasterId: portalClaimMaster.RmiUid,
      RmiCptCode: cpt.RmiProcCode,
      RmiCptModifier1: JSON.parse(values?.modifier || "{}").RmiModif,
      RmiCptModifier2: values.additionalModifiers
        ? JSON.parse(values.additionalModifiers[0]?.modifier || "{}").RmiModif
        : null,
      RmiCptModifier3: values.additionalModifiers
        ? JSON.parse(values.additionalModifiers[1]?.modifier || "{}").RmiModif
        : null,
      RmiCptModifier4: values.additionalModifiers
        ? JSON.parse(values.additionalModifiers[2]?.modifier || "{}").RmiModif
        : null,
      RmiCreatedBy: portalClaimMaster.RmiCreatedBy,
      RmiDays: parseInt(values.units),
      RmiDetailNote:
        values.ndcCode && values.ndcUnit
          ? values.ndcCode.trim().replace(/\D/g, "") + " " + values.ndcUnit
          : null,
      RmiDiagCode: values.additionalDiags
        ? values.additionalDiags?.RmiDiagCode
        : null,
      RmiDiagCode2: values.additionalAddedDiags
        ? JSON.parse(values.additionalAddedDiags[0]?.diag || "{}").RmiDiagCode
        : null,
      RmiDiagCode3: values.additionalAddedDiags
        ? JSON.parse(values.additionalAddedDiags[1]?.diag || "{}").RmiDiagCode
        : null,
      RmiDiagCode4: values.additionalAddedDiags
        ? JSON.parse(values.additionalAddedDiags[2]?.diag || "{}").RmiDiagCode
        : null,
      RmiDiagPtr: values.additionalDiags
        ? JSON.parse(values.additionalDiags || "{}").RmiIdx
        : null,
      RmiDiagPtr2: values.additionalAddedDiags
        ? JSON.parse(values.additionalAddedDiags[0]?.diag || "{}").RmiIdx
        : null,
      RmiDiagPtr3: values.additionalAddedDiags
        ? JSON.parse(values.additionalAddedDiags[1]?.diag || "{}").RmiIdx
        : null,
      RmiDiagPtr4: values.additionalAddedDiags
        ? JSON.parse(values.additionalAddedDiags[2]?.diag || "{}").RmiIdx
        : null,
      RmiDosFrom: values.procedureFrom,
      RmiDosFromString: values.procedureFrom,
      RmiDosTo: values.procedureTo,
      RmiDosToString: values.procedureTo,
      RmiEmg: values.emg,
      RmiEpsDt: "",
      RmiIdx: procDataSource.length + 1,
      RmiModifiedBy: portalClaimMaster.RmiModifiedBy,
      RmiNdcCode: values.ndcCode,
      RmiPosCode: JSON.parse(values.pos).RmiCode,
      RmiRendProviderFirstName: procDataSource[0].RmiRendProviderFirstName,
      RmiRendProviderId: procDataSource[0].RmiRendProviderId,
      RmiRendProviderLastName: procDataSource[0].RmiRendProviderLastName,
      RmiRendProviderNpi: values.renderingProvider,
      RmiTotalTime: null,
      RmiNetPaid: null,
      RmiUid: "",
      ndcCode: values.ndcCode,
      procedure: values.procedure,
      ndcUnit: values.ndcUnit,
      ndcQty: values.ndcQty,
    };

    for (let i = 0; i < procDataSource.length; i++) {
      if (procDataSource[i].RmiCptCode === row.RmiCptCode) {
        // duplicate
        notifier.error(
          "Duplicate CPT Code exists. Please select a different CPT code."
        );
        return;
      }
    }

    // Check if different POS
    if (JSON.parse(values.pos).Code !== pos && procDataSource.length !== 0) {
      // Different POS
      confirm({
        title: "Place of Service Difference.",
        icon: <ExclamationCircleOutlined />,
        content:
          "The POS on all service lines will be modified to match this one.",
        onOk: () => handlePos(values, row, true),
        onCancel() {},
      });
    } else {
      // Same POS
      if (procDataSource.length === 0) setPOS(JSON.parse(values.pos).Code);
      handlePos(values, row, false);
    }
  };

  const handlePos = (values: any, row: any, newPos: boolean) => {
    const selectedPOS = JSON.parse(values.pos);

    if (
      selectedPOS.RmiCode === "11" ||
      selectedPOS.RmiCode === "02" ||
      selectedPOS.RmiCode === "10"
    )
      setPosOffice(true);
    else setPosOffice(false);

    if (newPos) {
      setPOS(selectedPOS.Code); // Set POS to current
      setProcDataSource((prev) =>
        prev.map((val) => {
          return { ...val, POS: values.pos };
        })
      );
    }

    // Clear CPT and Charges
    form.resetFields([
      "cpt",
      "procedureCharges",
      "emg",
      "modifier",
      "units",
      "additionalModifiers",
      "additionalAddedDiags",
      "ndcCode",
    ]);
    setCPTCodesResult([]);
    setCPT({});
    setNdcRequired(false);

    // Get Name from NPI
    getNameFromNpi(values.renderingProvider);

    // Get Facilities
    getFacilities(selectedPOS);

    setProcDataSource((prev) => [...prev, row]);
  };

  const addEMCodetoProcTable = () => {
    if (selectedEMCode === "") return;
    else {
      const procData = {
        key: procDataSource.length.toString(),
        fromTo: (
          <>
            {" "}
            {moment(props.dos).format("MM/DD/YYYY")} <br />{" "}
            {moment(props.dos).format("MM/DD/YYYY")}{" "}
          </>
        ),
        RmiDosFrom: moment(props.dos).format("MM/DD/YYYY"),
        RmiDosTo: moment(props.dos).format("MM/DD/YYYY"),
        RmiPosCode: form.getFieldValue("pos"),
        RmiEmg: "N",
        RmiCptCode: selectedEMCode,
        modifiers: null,
        RmiDiagRefLetter: additionalDiags.RmiDiagRefLetter,
        RmiCharges: "0.01",
        RmiDays: 1,
        RmiRendProviderNpi: form.getFieldValue("renderingProvider"),
        procedure: "NDC",
        ndcCode: null,
        ndcUnit: "ML",
        ndcQty: "1",
        ndcTime: null,
        ndcTimeInMinutes: null,
        ndcFrom: null,
        ndcTo: null,
        RmiDiagCode: additionalDiags.RmiDiagCode,
        RmiIdx: additionalDiags.index,
        additionalModifiers: null,
        additionalDiags: null,
        additionalServiceInfo: null,
      };
      setProcDataSource((prev) => [...prev, procData]);
      setEMCodeSelectionModalVisible(false);
      Modal.success({
        title:
          selectedEMCode + " has been successfully added as a service line.",
        content:
          "Please re-submit the form after confirming the added information is correct.",
      });
    }
  };

  const handleSelectVendor = (value: string) => {
    let vendor = JSON.parse(value);
    form.setFields([
      { name: "vendorNPI", value: vendor.RmiVendorNpi },
      { name: "vendorName", value: vendor.RmiVendorName },
      { name: "vendorAddress", value: vendor.RmiStreet },
      { name: "vendorCity", value: vendor.RmiCity },
      { name: "vendorState", value: vendor.RmiState },
      { name: "vendorZip", value: vendor.RmiZip },
      { name: "vendorPhone", value: vendor.RmiPhone },
    ]);
  };

  const handleSelectFacility = (value: string) => {
    let facility = JSON.parse(value);
    setSelectedFacility(facility);
    form.setFields([
      { name: "facilityName", value: facility.LastName },
      { name: "facilityAddress", value: facility.Street },
      { name: "facilityCity", value: facility.City },
      { name: "facilityState", value: facility.State },
      { name: "facilityZip", value: facility.Zip },
    ]);
    form.validateFields([
      "facility",
      "facilityName",
      "facilityAddress",
      "facilityCity",
      "facilityState",
      "facilityZip",
    ]);
  };

  const checkMultipleEMCodes = async () => {
    //check if ambulatory codes set boolean to true
    let [
      hasAmbulatory,
      hasGCodes,
      hasQualityMeasureCode,
      hasEMCode,
      hasModifier25,
    ] = Array(5).fill(false);
    let emCount = 0;

    procDataSource.map((val) => {
      if (!hasAmbulatory && AMBULATORY_CODES.includes(val.RmiCptCode))
        hasAmbulatory = true;
      if (!hasGCodes && G_CODES.includes(val.RmiCptCode)) hasGCodes = true;
      if (
        !hasQualityMeasureCode &&
        measureCodes.find((x) => x.Code === val.RmiCptCode)
      )
        hasQualityMeasureCode = true;
    });
    //check if ambulatory is false and emcodes is not empty. if not, loop through portalClaimDetails.
    if (!hasAmbulatory && EMCodes.length > 0) {
      procDataSource.map((val) => {
        // add days to emCount if emCode is found
        if (EMCodes.find((x) => x.Code === val.RmiCptCode)) {
          hasEMCode = true;
          emCount++;
        }
        // if part of exclusion codes, and has modifier 25, allow for as many em codes as needed.
        if (
          EM_EXCLUSION_CODES.includes(val.RmiCptCode) &&
          (val.modifiers
            ? JSON.parse(val.modifiers).RmiModif === "25"
            : false) &&
          hasEMCode
        ) {
          hasModifier25 = true;
        }
      });
    }

    if (hasEMCode && emCount > 1 && !hasModifier25) {
      Modal.error({
        title: "Multiple E&M Codes.",
        content:
          "You have more than one E&M Code, For Claims, you can have only one E&M code.",
      });
      return false;
    }
    if (!hasEMCode && EMCodes.length > 0 && hasQualityMeasureCode) {
      // open EM Code modal
      setEMCodeSelectionModalVisible(true);
      return false;
    } else if (
      hasGCodes &&
      portalClaimMaster.RmiClaimSource === "E" &&
      props.provider.RmiClass === "P"
    ) {
      confirm({
        title: "ATTENTION",
        content:
          "PLEASE MAKE SURE YOU SUBMIT ANY HCC DX CODES FOR THIS DATE OF SERVICE",
        type: "warning",
        maskClosable: false,
        okText: "Proceed With Claim",
        cancelText: "Add DX Codes",
        onOk() {
          form.validateFields().then((values) => onSubmit(values));
        },
        onCancel() {
          return Promise.resolve(false);
        },
      });
      return false;
    } else {
      return true;
    }
  };

  // Upload Files
  const handleUpload = (claimRefNo: string) => {
    const fileData = new FormData();
    attachmentList.forEach((file: any) => {
      fileData.append("file", file, file.name);
    });

    fileData.append("rmiCompanyId", props.memberInfo.RmiCompanyId);
    fileData.append("rmiClaimReferenceNo", claimRefNo);
    fileData.append("rmiUserId", sessionStorage.getItem("user_id")!);
    fileData.append("date", moment().toString());
    fileData.append("updateAttachment", "0");

    return props
      .uploadAttachment(fileData)
      .then(() => {
        notifier.success("Document successfully uploaded.");
      })
      .catch((err: ErrorResponse) => {
        notifier.error(
          err.response?.data?.Message ||
            "Something went wrong, please contact a system administrator."
        );
      });
  };

  const onSubmitAlert = () => {
    setIsSubmitting(true);
    setSubmitFlag(true);
    form
      .validateFields()
      .then(async (values) => {
        // EM Code check
        // commenting this out as claim generator has a validateHEDISClaim() call on submission that is conflicting with this
        // let emCodeCheck = await checkMultipleEMCodes();

        props
          .checkBulkCPTCompability(procDataSource)
          .then((response: any) => {
            if (response.length > 0) {
              const cptCodes = response
                .map((cpt: any) => cpt.RmiCptCode)
                .join(", ");
              notifier.error(
                "Service code " + cptCodes + " requires a valid NDC code."
              );
            }

            if (response.length === 0) {
              confirm({
                title: "Are you sure you are done?",
                icon: <ExclamationCircleOutlined />,
                content:
                  "The claim will be submitted after you select OK and no further changes can be made.",
                onOk: () => onSubmit(values),
                onCancel() {},
              });
            }
          })
          .catch((err: ErrorResponse) => {
            notifier.error(
              err?.response?.data?.Message ||
                "Something went wrong, please contact a system administrator."
            );
          });
      })
      .catch((err) => {
        notifier.error(
          "Please resolve all field errors before submission, thank you."
        );
      });
  };

  const onSubmit = async (formValues: any) => {
    procDataSource.map((value: any, index: number) => {
      let diag2, diag3, diag4;
      let mod2,
        mod3,
        mod4 = "";
      if (value?.additionalDiags && value.additionalDiags.length > 0) {
        try {
          diag2 = JSON.parse(value.additionalDiags[0].diag);
        } catch {}
        try {
          value.additionalDiags[1] &&
            (diag3 = JSON.parse(value.additionalDiags[1].diag));
        } catch {}
        try {
          value.additionalDiags[2] &&
            (diag4 = JSON.parse(value.additionalDiags[2].diag));
        } catch {}
      }

      if (value?.additionalModifiers && value.additionalModifiers.length > 0) {
        try {
          mod2 = JSON.parse(value.additionalModifiers[0].modifier).RmiModif;
        } catch {}
        try {
          value.additionalModifiers[1] &&
            (mod3 = JSON.parse(value.additionalModifiers[1].modifier).RmiModif);
        } catch {}
        try {
          value.additionalModifiers[2] &&
            (mod4 = JSON.parse(value.additionalModifiers[2].modifier).RmiModif);
        } catch {}
      }

      let detailNote = "";
      if (value.procedure === "NDC")
        detailNote = `${value.procedure}${value.ndcCode ? value.ndcCode : ""} ${
          value.ndcUnit ? value.ndcUnit : ""
        }${value.ndcQty ? value.ndcQty : ""}`;
      else
        detailNote = `${value.procedure} ${
          value.additionalServiceInfo ? value.additionalServiceInfo : ""
        }`;
    });

    // prepare diagnoses array
    let diagInfo = diagDataSource.map((value) => {
      return { ...value, RmiDiagRefLetter: toLetters(value.RmiIdx) };
    });

    let formData = {
      portalClaimMaster: {
        ...portalClaimMaster,
        RmiOtherInsuredName: formValues.insuredName
          ? formValues.insuredName
          : null,
        RmiOtherInsuredPolicy: formValues.insuredPolicyGroupNo
          ? formValues.insuredPolicyGroupNo
          : null,
        RmiOtherInsuredPlan: formValues.insurancePlan
          ? formValues.insurancePlan
          : null,
        RmiEmploymentRelated: patientInfo.employmentAccident
          ? patientInfo.employmentAccident
          : null,
        RmiAutoRelated: patientInfo.autoAccident
          ? patientInfo.autoAccident
          : null,
        RmiAutoAccidentState: patientInfo.autoAccidentState
          ? patientInfo.autoAccidentState
          : null,
        RmiOtherRelated: patientInfo.otherAccident
          ? patientInfo.otherAccident
          : null,
        RmiInsuredOtherPlan: patientInfo.otherPlan
          ? patientInfo.otherPlan
          : null,
        RmiDateOfCurrent: currentDate !== "" ? currentDate : null,
        RmiDateOfSimilar: otherDate !== "" ? otherDate : null,
        RmiDateNoWorkFrom: formValues.unavailableFrom
          ? formValues.unavailableFrom
          : null,
        RmiDateNoWorkTo: formValues.unavailableTo
          ? formValues.unavailableTo
          : null,
        RmiReferringProviderId: null,
        RmiReferringProvider: formValues.provider ? formValues.provider : null,
        RmiReferringProviderNpi: formValues.npi ? formValues.npi : null,
        RmiHospitalizedFrom: formValues.hospitalFrom
          ? formValues.hospitalFrom
          : null,
        RmiHospitalizedTo: formValues.hospitalTo ? formValues.hospitalTo : null,
        RmiOutsideLab: formValues.outsideLab ? formValues.outsideLab : null,
        RmiOutsideLabCharge: formValues.RmiCharges
          ? formValues.RmiCharges
          : null,
        RmiPatientAcctNo: patientAccount,
        RmiMedicaidResubCode: formValues.resubCode
          ? formValues.resubCode
          : null,
        RmiMedicaidOrigRefNo: formValues.originalRefNo
          ? formValues.originalRefNo
          : null,
        RmiPriorAuthNo: formValues.priorAuthNo ? formValues.priorAuthNo : null,
        RmiTotalCharge: parseFloat(totalCharges).toFixed(2),
        RmiAmountPaid: parseInt(amountPaid),
        RmiBalanceDue: parseFloat(balance).toFixed(2),
        RmiFacilityName: formValues.facilityName
          ? formValues.facilityName
          : null,
        RmiFacilityAddrId: selectedFacility.AddressId,
        RmiFacilityAddress: formValues.facilityAddress
          ? formValues.facilityAddress
          : null,
        RmiFacilityCity: formValues.facilityCity
          ? formValues.facilityCity
          : null,
        RmiFacilityState: formValues.facilityState
          ? formValues.facilityState
          : null,
        RmiFacilityZip: formValues.facilityZip ? formValues.facilityZip : null,
        RmiFacilityNpi: formValues.facilityNPI ? formValues.facilityNPI : null,
        RmiFacilityId: null,
        RmiBillingProviderId: formValues.vendor
          ? JSON.parse(formValues.vendor).RmiVendorId
          : null,
        RmiBillingProviderName: formValues.vendorName
          ? formValues.vendorName
          : null,
        RmiBillingProviderAddrId: null,
        RmiBillingProviderAddress: formValues.vendorAddress
          ? formValues.vendorAddress
          : null,
        RmiBillingProviderCity: formValues.vendorCity
          ? formValues.vendorCity
          : null,
        RmiBillingProviderState: formValues.vendorState
          ? formValues.vendorState
          : null,
        RmiBillingProviderZip: formValues.vendorZip
          ? formValues.vendorZip
          : null,
        RmiBillingProviderPhone: formValues.vendorPhone
          ? formValues.vendorPhone
          : null,
        RmiBillingProviderNpi: formValues.vendorNPI
          ? formValues.vendorNPI
          : null,
        RmiPosCode: pos ? pos.replace(/[^0-9]/g, "") : null,
        RmiProvId: props.provider.RmiProvId ? props.provider.RmiProvId : null,
        RmiProvKeyId: props.memberInfo.RmiProvKeyId
          ? props.memberInfo.RmiProvKeyId
          : null,
        RmiClaimNote: formValues.additionalClaimInfo
          ? formValues.additionalClaimInfo
          : null,
        RmiClaimSource: "E", //E: Eligibility claim, I: Interactive claim
      },
      portalClaimDetails: procDataSource, //claim generator final submission page popup2 data
      portalClaimDiags: diagInfo, //claim generator final submission page popup2 data
    };

    if (procDataSource.length === 0) {
      notifier.error("Please add one or more details.");
      return;
    }

    //claim generator final submission page different save API
    props
      .validateHedisClaim(formData)
      .then((errorMessages: string[]) => {
        if (errorMessages.length === 0) {
          props
            .saveHedisClaim(formData)
            .then((saveHedisClaimResponse: any) => {
              //update the measure status for the first claim generator page
              handleUpload(saveHedisClaimResponse.ClaimReferenceNo);
              const memberMeasureStatus = "readytosubmit";
              props
                .getMemberMeasures(
                  props.memberInfo,
                  props.measureYear,
                  memberMeasureStatus
                )
                .then((getMemberMeasuresResponse: any) => {
                  return getMemberMeasuresResponse.filter(
                    (measure: any) =>
                      moment(measure.RmiDosFrom).format("MM/DD/YYYY") ===
                      moment(procDataSource[0].RmiDosFrom).format("MM/DD/YYYY")
                  );
                })
                .then(async (filteredMeasures: any) => {
                  Promise.all(
                    filteredMeasures.map((measure: any) => {
                      props.updateMemberMeasureForClaimSubmission(
                        measure,
                        "Processing",
                        "Completed",
                        props.measureYear,
                        saveHedisClaimResponse.ClaimReferenceNo
                      );
                    })
                  );
                })
                .then(() => {
                  setShowClaimSubmitted(true);
                  //wait like 3 seconds to let the user see the success message at the bottom of the page before redirecting back to the measure list page
                  setTimeout(() => {
                    history.push({
                      pathname: "/eligibility/member-detail",
                      state: {
                        previousPath: "/eligibility/claim-final-submission",
                        eligibilityMemberInfo: props.memberInfo,
                        primaryCareProvider: props.provider,
                        breadcrumbs: [
                          {
                            pathname: "/quality/overview",
                            name: "Home",
                            icon: "",
                          },
                          {
                            pathname: "/eligibility/search",
                            name: "Member Search",
                            icon: "",
                          },
                          {
                            pathname: "/eligibility/member-detail",
                            name: "Member Eligibility and Assessment",
                            icon: "",
                            state: { eligibilityMemberInfo: props.memberInfo },
                          },
                        ],
                      },
                    });
                  }, 3000);
                });
            })
            .catch((err: any) => {
              setShowClaimSubmitted(false);
              notifier.error(
                err?.response?.data ||
                  "Something went wrong, please contact a system administrator."
              );
            });
        } else {
          notifier.error(errorMessages.join(", "));
        }
      })
      .catch((err: any) => {
        setShowClaimSubmitted(false);
        notifier.error(
          err?.response?.data ||
            "Something went wrong, please contact a system administrator."
        );
      });
  };

  return (
    <Form
      form={form}
      className="claim-generator-form"
      name="claimForm"
      onFinish={onSubmit}
      initialValues={{
        procedure: "NDC",
        ndcUnit: "ML",
        ndcQty: "1",
        ndcFrom: moment(),
        ndcTo: moment(),
        procedureFrom: moment(props.dos),
        procedureTo: moment(props.dos),
        emg: "N",
        units: "1",
      }}
    >
      <LoadingIndicator
        isLoading={
          props.isCreating ||
          props.isFetchingVendors ||
          props.isFetchingPOS ||
          props.isFetchingNPI ||
          props.isFetchingModifierCodes
        }
        fullScreen
      />
      <OtherProviderModal
        otherProviders={otherProviders}
        isFetching={props.isFetchingOther}
        visible={otherProviderModalVisible}
        onCancel={() => setOtherProviderModalVisible(false)}
        clickOtherProvider={clickOtherProvider}
      />
      <EMCodeSelectionModal
        EMCodeList={EMCodes}
        selectedEMCode={selectedEMCode}
        setSelectedEMCode={setSelectedEMCode}
        visible={EMCodeSelectionModalVisible}
        onCancel={() => {
          Modal.error({
            title:
              "E&M code is required for claims with Quality Performance codes.",
          });
        }}
        onOk={() => addEMCodetoProcTable()}
      />
      <PatientInfo
        portalClaimMaster={portalClaimMaster}
        patientInfo={patientInfo}
        setPatientInfo={setPatientInfo}
        form={form}
      />
      <div className="row flex-lg-wrap justify-content-start ml-0 mt-3">
        <Title level={4}>Physician or Supplier Information</Title>
        <div className="member-search row flex-lg-wrap justify-content-start ml-0">
          <div className="col-lg-8 col-md-8">
            <FloatLabel
              label="Current Illness, Injury, or Pregnancy (LMP) Date"
              name="currentDate"
              form={form}
              small="(box 14)"
              value={currentDate}
            >
              <DatePickerLocalised
                date={currentDate}
                setDate={setCurrentDate}
                allowClear
              />
            </FloatLabel>

            <FloatLabel
              label="Other Date"
              name="otherDate"
              form={form}
              small="(box 15)"
              value={otherDate}
            >
              <DatePickerLocalised
                date={otherDate}
                setDate={setOtherDate}
                allowClear
              />
            </FloatLabel>

            {patientInfo.employmentAccident === "Y" && (
              <>
                <Divider />
                <FloatLabel
                  label="Unavailable to Work From"
                  name="unavailableFrom"
                  form={form}
                  small="(box 16)"
                  required
                  dependencies={["unavailableTo"]}
                  rules={[
                    ({ getFieldValue }) => ({
                      async validator(_: any, value: any) {
                        if (
                          value &&
                          getFieldValue("unavailableTo") &&
                          !moment(getFieldValue("unavailableTo")).isSameOrAfter(
                            moment(value)
                          )
                        ) {
                          return Promise.reject(
                            new Error(
                              "Please enter a date that is on or before the To Date."
                            )
                          );
                        }
                        return Promise.resolve();
                      },
                    }),
                  ]}
                >
                  <DatePickerLocalised
                    date={unavailableFrom}
                    setDate={setUnavailableFrom}
                    formInstance={form}
                    formItemName={"unavailableFrom"}
                  />
                </FloatLabel>

                <FloatLabel
                  label="Unavailable to Work To"
                  name="unavailableTo"
                  form={form}
                  small="(box 16b)"
                  required
                >
                  <DatePickerLocalised
                    date={unavailableTo}
                    setDate={setUnavailableTo}
                    formInstance={form}
                    formItemName={"unavailableTo"}
                  />
                </FloatLabel>

                <br />
              </>
            )}
          </div>

          <div className="col-lg-4 col-md-4">
            <FloatLabel
              label="Referring Provider"
              name="provider"
              form={form}
              small="(box 17)"
              required={props.provider.RmiClass === "S"}
              dependencies={["npi"]}
              validateTrigger={["onBlur", "onChange"]}
              rules={[
                ({ getFieldValue }) => ({
                  async validator(_: any, value: any) {
                    if ((!value && !getFieldValue("npi")) || value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("Must enter NPI with Referring Provider.")
                    );
                  },
                }),
              ]}
            >
              <Input
                onChange={(e) => {
                  setReferringProvider(e.target.value);
                }}
              />
            </FloatLabel>

            <FloatLabel
              label="NPI"
              name="npi"
              form={form}
              small="(box 17b)"
              validateTrigger={["onBlur"]}
              dependencies={["provider"]}
              hasFeedback
              rules={[
                ({ getFieldValue }) => ({
                  async validator(_: any, value: any) {
                    if (
                      (!value && !getFieldValue("provider")) ||
                      (value && (await verifyNPI(value)))
                    ) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        "This NPI does not exist on our system. Please revise your entry."
                      )
                    );
                  },
                }),
              ]}
            >
              <Input
                type="number"
                onKeyDown={(evt) =>
                  (evt.key === "e" ||
                    evt.key === "+" ||
                    evt.key === "-" ||
                    evt.key === ".") &&
                  evt.preventDefault()
                }
                onChange={(e) => {
                  setNpi(e.target.value);
                }}
              />
            </FloatLabel>
          </div>

          <div className="col-lg-4 col-md-4">
            <FloatLabel
              label="Hospitalization From"
              name="hospitalFrom"
              form={form}
              small="(box 18)"
              dependencies={["hospitalTo"]}
              required={procDataSource.some((val: any) =>
                HOSPITALIZATION_REQUIRED_POS_CODE.includes(val.RmiPosCode)
              )}
              rules={[
                ({ getFieldValue }: any) => ({
                  async validator(__: any, value: any) {
                    if (
                      value &&
                      getFieldValue("hospitalTo") &&
                      !moment(getFieldValue("hospitalTo")).isSameOrAfter(
                        moment(value)
                      )
                    ) {
                      return Promise.reject(
                        new Error(
                          "Please enter a date that is on or before the To Date."
                        )
                      );
                    } else {
                      // Check if Hospitalization From is before dosFrom and dosTo in the cpt code list, need for loop to resolve Promise.
                      // value input is just "date" while RmiDosFrom and RmiDosTo both have the database time in there...
                      const minDate = _.min(
                        procDataSource.map((value) => {
                          return new Date(value.RmiDosFrom);
                        })
                      );
                      const maxDate = _.max(
                        procDataSource.map((value) => {
                          return new Date(value.RmiDosTo);
                        })
                      );

                      if (
                        moment(moment(value).format("MM/DD/YYYY")).isBefore(
                          moment(moment(minDate).format("MM/DD/YYYY"))
                        ) ||
                        moment(moment(value).format("MM/DD/YYYY")).isAfter(
                          moment(moment(maxDate).format("MM/DD/YYYY"))
                        )
                      ) {
                        return Promise.reject(
                          "Hospital From Date is not in the procedure date range."
                        );
                      }
                    }

                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <DatePickerLocalised
                date={hospitalFrom}
                setDate={setHospitalFrom}
                formInstance={form}
                formItemName={"hospitalFrom"}
                allowClear
              />
            </FloatLabel>

            <FloatLabel
              label="Hospitalization To"
              name="hospitalTo"
              form={form}
              small="(box 18b)"
              rules={[
                () => ({
                  async validator(__: any, value: any) {
                    // Check if Hospitalization To is before dosFrom and dosTo in the cpt code list, need for loop to resolve Promise.
                    // value input is just "date" while RmiDosFrom and RmiDosTo both have the database time in there...
                    const minDate = _.min(
                      procDataSource.map((value) => {
                        return new Date(value.RmiDosFrom);
                      })
                    );
                    const maxDate = _.max(
                      procDataSource.map((value) => {
                        return new Date(value.RmiDosTo);
                      })
                    );

                    if (
                      moment(moment(value).format("MM/DD/YYYY")).isBefore(
                        moment(moment(minDate).format("MM/DD/YYYY"))
                      ) ||
                      moment(moment(value).format("MM/DD/YYYY")).isAfter(
                        moment(moment(maxDate).format("MM/DD/YYYY"))
                      )
                    ) {
                      return Promise.reject(
                        "Hospital To Date is not in the procedure date range."
                      );
                    }

                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <DatePickerLocalised
                date={hospitalTo}
                setDate={setHospitalTo}
                formInstance={form}
                formItemName={"hospitalTo"}
                allowClear
              />
            </FloatLabel>
          </div>

          <div className="col-lg-4 col-md-4">
            <FloatLabel
              label="Resubmission Code"
              name="resubCode"
              form={form}
              small="(box 22)"
            >
              <Select onChange={(e) => setResubCode(e!.toString())}>
                <Option value="1">1 - Original Claim</Option>
                <Option value="7">7 - Replacement of Prior Claim</Option>
                <Option value="8">8 - Void/Cancel Prior Claim</Option>
              </Select>
            </FloatLabel>

            <FloatLabel
              label="Original Ref No"
              name="originalRefNo"
              form={form}
              dependencies={["resubCode"]}
              validateTrigger={["onBlur", "onChange"]}
              rules={[
                () => ({
                  async validator(_: any, value: any) {
                    if (
                      ((resubCode === ResubCodes.REPLACEMENT ||
                        resubCode === ResubCodes.VOID) &&
                        value) ||
                      (resubCode !== ResubCodes.REPLACEMENT &&
                        resubCode !== ResubCodes.VOID)
                    ) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("Please enter original reference number.")
                    );
                  },
                }),
              ]}
            >
              <Input />
            </FloatLabel>
          </div>

          <div className="col-lg-4 col-md-4">
            <FloatLabel
              label="Outside Lab?"
              name="outsideLab"
              small="(box 20)"
              form={form}
              value={"Yes"}
            >
              <Radio.Group className="radio">
                <Radio.Button value="Y">Yes</Radio.Button>
                <Radio.Button value="N">No</Radio.Button>
              </Radio.Group>
            </FloatLabel>

            <FloatLabel label="Charges" name="charges" form={form} hasIcon>
              <Input
                type="number"
                prefix="$"
                onKeyDown={(evt) =>
                  (evt.key === "e" ||
                    evt.key === "+" ||
                    evt.key === "-" ||
                    evt.key === ".") &&
                  evt.preventDefault()
                }
              />
            </FloatLabel>

            <FloatLabel
              label="Prior Auth No"
              name="priorAuthNo"
              small="(box 23)"
              form={form}
              validateTrigger={["onBlur"]}
              hasFeedback
              rules={[
                () => ({
                  async validator(_: any, value: any) {
                    let authDetail = await getAuthDetail(value);
                    if (!value || authDetail.length !== 0) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        "This Auth does not exist in our system or this member does not possess this Auth Number. Please revise your entry."
                      )
                    );
                  },
                }),
              ]}
            >
              <Input
                type="number"
                onKeyDown={(evt) =>
                  (evt.key === "e" ||
                    evt.key === "+" ||
                    evt.key === "-" ||
                    evt.key === ".") &&
                  evt.preventDefault()
                }
              />
            </FloatLabel>
          </div>

          <div className="col-lg-24 col-md-4 mb-1">
            <Title level={5}>
              Additional Claim Information{" "}
              <span style={{ fontSize: "11px" }}>(box 19)</span>
            </Title>
            <Form.Item name="additionalClaimInfo">
              <Input />
            </Form.Item>
          </div>

          <div className="col-lg-24 col-md-24 mb-3">
            <Title level={5}>
              Diagnosis Information (ICD 10){" "}
              <span style={{ color: "red" }}>*</span>{" "}
              <span style={{ fontSize: "11px" }}>
                (Min 1, Max 12 boxes 21A-L)
              </span>
            </Title>
            <div style={{ color: "red" }}>{diagErrorMsg}</div>
            {diagDataSource.length !== 0 && (
              <Table
                columns={diagColumns}
                dataSource={diagDataSource}
                pagination={false}
                rowKey={"RmiDiagCode"}
              />
            )}
            <Form.Item
              name="diagnosis"
              validateTrigger={["onBlur"]}
              rules={[
                {
                  required: diagDataSource.length === 0,
                  message: "Please add at least 1 Diagnosis.",
                },
              ]}
            >
              <AutoComplete
                style={{ width: "100%" }}
                ref={scrollToRef}
                onSearch={debounce(handleDiagCodeSearch, 500)}
                onSelect={handleSelectDiagCode}
                placeholder="Search for Diagnosis Codes..."
                notFoundContent={
                  "Not found. Please type more than 3 characters or try your search again."
                }
              >
                {props.isFetchingDiagCodes ? (
                  <Option value="">
                    <Spin />
                  </Option>
                ) : (
                  diagCodeResult.map((value: any) => (
                    <Option key={value.diagcode} value={JSON.stringify(value)}>
                      {value.diagcode}
                    </Option>
                  ))
                )}
              </AutoComplete>
            </Form.Item>
          </div>

          <div className="col-lg-24 col-md-24 mb-3">
            <Title level={5}>
              Procedure Information{" "}
              <span style={{ fontSize: "11px" }}>(boxes 24A-J)</span>
            </Title>
            <Form.Item
              name="procTable"
              validateStatus={procDataSource.length === 0 ? "error" : "success"}
              help={
                procDataSource.length === 0 &&
                submitFlag &&
                "Please add at least 1 Service Line."
              }
              style={{ marginTop: "-40px" }}
            />
          </div>

          {/* Claim generator final submission page additional props */}
          {procDataSource.length !== 0 && (
            <ProcedureTable
              procDataSource={procDataSource}
              setProcDataSource={setProcDataSource}
              form={form}
              modifierCodes={modifierCodes}
              isFetchingModifierCodes={props.isFetchingModifierCodes}
              diagDataSource={diagDataSource}
              setPosOffice={setPosOffice}
              setPatientAccount={setPatientAccount}
              setAmountPaid={setAmountPaid}
              amountPaid={amountPaid}
              setTotalCharges={setTotalCharges}
              setBalance={setBalance}
              checkCPTCompatibility={checkCPTCompatibility}
              getRelated={props.getRelated}
              getNdcCodes={props.getNdcCodes}
              isFetchingNdcCodes={props.isFetchingNdcCodes}
              handleCPTCodeSearch={handleCPTCodeSearch}
              CPTCodesResult={CPTCodesResult}
              setCPTCodesResult={setCPTCodesResult}
              isFetchingCPTCodes={props.isFetchingCPTCodes}
              setMissingCPTCode={setMissingCPTCode}
              checkIfNdcIsRequired={props.checkIfNdcIsRequired}
            />
          )}
          <div className="procedure-info row flex-lg-wrap justify-content-start mb-3 ml-0">
            <div className="col-xs-4 col-md-4 mb-3">
              <FloatLabel label="Select:" name="procedure" form={form}>
                <Select value={procedure} onSelect={(e) => setProcedure(e)}>
                  <Option value="NDC">NDC</Option>
                  <Option value="ZZ">ZZ</Option>
                </Select>
              </FloatLabel>
            </div>
            {procedure !== "ZZ" ? (
              <>
                <div className="col-xs-6 col-md-6 mb-3">
                  <FloatLabel
                    label="NDC Code:"
                    name="ndcCode"
                    form={form}
                    validateTrigger={["onBlur"]}
                    dependencies={["ndcQty"]}
                    hasFeedback
                    required={
                      !isSubmitting &&
                      datesVisible &&
                      parseInt(form.getFieldValue(["ndcQty"])) > 1
                    }
                    rules={[
                      () => ({
                        validator: validateNDC,
                      }),
                      () => ({
                        async validator(_: any, value: any) {
                          if (ndcRequired && !value && !isSubmitting) {
                            return Promise.reject(
                              new Error("NDC Code is required.")
                            );
                          }
                          return Promise.resolve();
                        },
                      }),
                    ]}
                    float
                  >
                    <AutoComplete
                      id="ndc-code"
                      style={{ width: "100%" }}
                      onSearch={debounce(handleNdcCodeSearch, 500)}
                      onSelect={handleSelectNdcCode}
                      notFoundContent={
                        "Not found. Please type more than 3 characters or try your search again."
                      }
                      defaultActiveFirstOption={true}
                      onKeyDown={(e) =>
                        tabSelectEvent(e, ndcCodeResult, "ndc-code")
                      }
                      maxLength={11}
                      allowClear
                    >
                      {props.isFetchingNdcCodes ? (
                        <Option value="">
                          <Spin />
                        </Option>
                      ) : (
                        ndcCodeResult.map((option: any, key: number) => (
                          <Option key={key} value={JSON.stringify(option)}>
                            {option.codeName}
                          </Option>
                        ))
                      )}
                    </AutoComplete>
                  </FloatLabel>
                </div>
                <div className="col-xs-3 col-md-3 mb-3">
                  <FloatLabel label="Unit:" name="ndcUnit" form={form}>
                    <Select>
                      <Option value="ME">ME</Option>
                      <Option value="ML">ML</Option>
                      <Option value="UN">UN</Option>
                      <Option value="GR">GR</Option>
                      <Option value="F2">F2</Option>
                    </Select>
                  </FloatLabel>
                </div>
                <div className="col-xs-3 col-md-3 mb-3">
                  <FloatLabel label="Qty:" name="ndcQty" form={form}>
                    <Input
                      type="number"
                      onKeyDown={(evt) =>
                        (evt.key === "e" ||
                          evt.key === "+" ||
                          evt.key === "-") &&
                        evt.preventDefault()
                      }
                    />
                  </FloatLabel>
                </div>
                {datesVisible && (
                  <div className="row col-lg-8 col-md-4 col-xs-4">
                    <div className="col-xs-12 col-md-12">
                      <FloatLabel label="From:" name="ndcFrom" form={form}>
                        <TimePicker
                          placeholder=""
                          use12Hours
                          showNow
                          onBlur={() => calculateTotalTime()}
                          allowClear={false}
                        />
                      </FloatLabel>
                      <div className="btn-wrapper">
                        <Button
                          type="primary"
                          size="small"
                          onClick={() => {
                            form.resetFields(["ndcFrom", "ndcTo"]);
                            calculateTotalTime();
                          }}
                          style={{ width: "100%", margin: "0 4px 0 0" }}
                        >
                          RESET
                        </Button>
                        <Button
                          size="small"
                          onClick={() => {
                            form.setFields([
                              { name: "ndcFrom", value: undefined },
                              { name: "ndcTo", value: undefined },
                              { name: "ndcTime", value: undefined },
                            ]);
                            setDatesVisible(false);
                          }}
                          style={{ width: "100%", margin: "0 0 0 4px" }}
                        >
                          REMOVE
                        </Button>
                      </div>
                    </div>
                    <div className="col-xs-12 col-md-12">
                      <FloatLabel
                        label="To:"
                        name="ndcTo"
                        form={form}
                        validateStatus={"success"}
                        help={"Total time: " + totalTime}
                      >
                        <TimePicker
                          placeholder=""
                          use12Hours
                          showNow
                          onBlur={() => calculateTotalTime()}
                          allowClear={false}
                        />
                      </FloatLabel>
                    </div>
                  </div>
                )}
                {!datesVisible && (
                  <div className="col-xs-8 col-md-8 mt-1 btn-wrapper">
                    <Button
                      type="primary"
                      style={{ width: "100%" }}
                      onClick={() => {
                        form.setFields([
                          { name: "ndcFrom", value: moment() },
                          { name: "ndcTo", value: moment() },
                        ]);
                        setDatesVisible(true);
                        calculateTotalTime();
                      }}
                    >
                      ADD NDC TIME
                    </Button>
                  </div>
                )}
              </>
            ) : (
              <div className="col-xs-12 col-md-12 mb-3">
                <FloatLabel
                  label="Additional Service Information"
                  name="additionalServiceInfo"
                  form={form}
                >
                  <Input />
                </FloatLabel>
              </div>
            )}
          </div>

          <div className="col-lg-4 col-md-4">
            <FloatLabel
              label="From Date:"
              name="procedureFrom"
              form={form}
              dependencies={["procedureTo"]}
              required={!isSubmitting}
              rules={[
                ({ getFieldValue }: any) => ({
                  async validator(_: any, value: any) {
                    if (value && moment(value).isAfter(moment().endOf("day"))) {
                      setDisableCptCode(true);
                      return Promise.reject(
                        new Error("Enter a date that is today or earlier")
                      );
                    }

                    if (
                      value &&
                      getFieldValue("procedureTo") &&
                      !moment(getFieldValue("procedureTo")).isSameOrAfter(
                        moment(value)
                      )
                    ) {
                      setDisableCptCode(true);
                      return Promise.reject(
                        new Error(
                          "Please enter a date that is on or before the To Date."
                        )
                      );
                    }

                    setDisableCptCode(false);
                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <DatePickerLocalised
                date={dosFrom}
                setDate={setDosFrom}
                formInstance={form}
                formItemName={"procedureFrom"}
                allowClear
              />
            </FloatLabel>

            <FloatLabel
              label="To Date:"
              name="procedureTo"
              form={form}
              dependencies={["procedureFrom"]}
              required={!isSubmitting}
              rules={[
                ({ getFieldValue }: any) => ({
                  async validator(_: any, value: any) {
                    if (value && moment(value).isAfter(moment().endOf("day"))) {
                      setDisableCptCode(true);
                      return Promise.reject(
                        new Error("Enter a date that is today or earlier")
                      );
                    }

                    if (
                      value &&
                      getFieldValue("procedureFrom") &&
                      !moment(getFieldValue("procedureFrom")).isSameOrBefore(
                        moment(value)
                      )
                    ) {
                      setDisableCptCode(true);
                      return Promise.reject(
                        new Error(
                          "Please enter a date that is on or after the From Date."
                        )
                      );
                    }

                    setDisableCptCode(false);
                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <DatePickerLocalised
                date={dosTo}
                setDate={setDosTo}
                formInstance={form}
                formItemName={"procedureTo"}
                allowClear
              />
            </FloatLabel>
          </div>

          <div className="col-lg-4 col-md-4">
            <FloatLabel
              label="POS"
              name="pos"
              form={form}
              rules={[{ required: !isSubmitting, message: "Required" }]}
              star
            >
              <Select showSearch loading={props.isFetchingPOS}>
                {posList.map((option: any, key: number) => {
                  return (
                    <Option key={key} value={JSON.stringify(option)}>
                      {option.Code}
                    </Option>
                  );
                })}
              </Select>
            </FloatLabel>

            <FloatLabel
              label="EMG"
              name="emg"
              form={form}
              rules={[
                { required: !isSubmitting, message: "Required" },
                () => ({
                  async validator(_: any, value: string) {
                    if (
                      value &&
                      value.trim().toUpperCase() !== "N" &&
                      value.trim().toUpperCase() !== "Y"
                    ) {
                      return Promise.reject(
                        new Error("Emergency value incorrect. Must be Y or N.")
                      );
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
              star
            >
              <Input />
            </FloatLabel>
          </div>

          <div className="col-lg-8 col-md-4">
            <FloatLabel
              label="CPT/HCPCS"
              name="cpt"
              form={form}
              float
              rules={[
                () => ({
                  async validator(_: any) {
                    if (!cpt.RmiProcCode && !isSubmitting) {
                      return Promise.reject(
                        new Error(
                          "Please select a CPT code from the dropdown list."
                        )
                      );
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
              star
            >
              <AutoComplete
                style={{ width: "100%" }}
                onSearch={debounce(handleCPTCodeSearch, 500)}
                onSelect={handleCPTCodeSelect}
                placeholder="Search for CPT Codes..."
                notFoundContent={
                  "Not found. Please type more than 2 characters or try your search again."
                }
                allowClear
                disabled={disableCptCode}
              >
                {props.isFetchingCPTCodes ? (
                  <Option value="">
                    <Spin />
                  </Option>
                ) : (
                  CPTCodesResult.map((value: any) => (
                    <Option
                      key={value.RmiProcCode}
                      value={JSON.stringify(value)}
                    >
                      {value.ServiceCode}
                    </Option>
                  ))
                )}
              </AutoComplete>
            </FloatLabel>

            <div className="row">
              <div className="col-lg-12 col-md-12">
                <FloatLabel
                  label="Modifier 1"
                  name="modifier"
                  form={form}
                  className="mb-4"
                >
                  <Select
                    showSearch
                    loading={props.isFetchingModifierCodes}
                    allowClear
                  >
                    {modifierCodes.map((value: any) => (
                      <Option
                        key={value.RmiCodeDesc}
                        value={JSON.stringify(value)}
                      >
                        {value.RmiCodeDesc}
                      </Option>
                    ))}
                  </Select>
                </FloatLabel>

                <Form.List name="additionalModifiers">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(
                        ({ key, name, fieldKey, ...restField }, index) => (
                          <Space key={key} align={"baseline"}>
                            <Form.Item
                              {...restField}
                              name={[name, "modifier"]}
                              fieldKey={[fieldKey, "modifier"]}
                            >
                              <Select
                                showSearch
                                loading={props.isFetchingModifierCodes}
                                placeholder={"Modifier " + (index + 2)}
                                style={{ width: "200px" }}
                              >
                                {modifierCodes.map((value: any) => (
                                  <Option
                                    key={value.RmiCodeDesc}
                                    value={JSON.stringify(value)}
                                  >
                                    {value.RmiCodeDesc}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>

                            <CloseOutlined onClick={() => remove(name)} />
                          </Space>
                        )
                      )}

                      {fields.length < 3 && (
                        <Form.Item>
                          <Button
                            type="dashed"
                            onClick={() => add()}
                            block
                            icon={<PlusOutlined />}
                          >
                            Add Modifier
                          </Button>
                        </Form.Item>
                      )}
                    </>
                  )}
                </Form.List>
              </div>

              <div className="col-lg-12 col-md-12">
                <FloatLabel
                  label="Diagnosis 1"
                  name="additionalDiags"
                  form={form}
                  rules={[{ required: !isSubmitting, message: "Required" }]}
                  star
                  className="mb-4"
                >
                  <Select
                    onSelect={(value: any) =>
                      setAdditionalDiags(JSON.parse(value))
                    }
                  >
                    {diagDataSource.map((value: any, index: number) => (
                      <Option
                        key={value.RmiDiagCode}
                        value={JSON.stringify({
                          ...value,
                          RmiIdx: index + 1,
                          RmiDiagRefLetter: toLetters(index + 1),
                        })}
                      >
                        {value.RmiDiagCode}
                      </Option>
                    ))}
                  </Select>
                </FloatLabel>

                <Form.List name="additionalAddedDiags">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }, index) => (
                        <Space key={key} align={"baseline"}>
                          <Form.Item
                            {...restField}
                            name={[name, "diag"]}
                            rules={[
                              { required: !isSubmitting, message: "Required" },
                            ]}
                          >
                            <Select
                              placeholder={<>Diagnosis {index + 2}</>}
                              style={{ width: "200px" }}
                            >
                              {diagDataSource.map(
                                (value: any, index: number) => (
                                  <Option
                                    key={value.RmiDiagCode}
                                    value={JSON.stringify({
                                      ...value,
                                      RmiIdx: index + 1,
                                      RmiDiagRefLetter: toLetters(index + 1),
                                    })}
                                  >
                                    {value.RmiDiagCode}
                                  </Option>
                                )
                              )}
                            </Select>
                          </Form.Item>

                          <CloseOutlined onClick={() => remove(name)} />
                        </Space>
                      ))}

                      {fields.length < 3 && (
                        <Form.Item>
                          <Button
                            type="dashed"
                            onClick={() => add()}
                            block
                            icon={<PlusOutlined />}
                          >
                            Add Diagnosis
                          </Button>
                        </Form.Item>
                      )}
                    </>
                  )}
                </Form.List>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-4">
            <FloatLabel
              label="Charges"
              name="procedureCharges"
              form={form}
              rules={[
                { required: !isSubmitting, message: "Required" },
                () => ({
                  async validator(_: any, value: string) {
                    if (
                      value &&
                      (isNaN(parseInt(value)) || parseInt(value) <= 0)
                    ) {
                      return Promise.reject(new Error("Incorrect charges."));
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
              hasIcon
              star
            >
              <Input
                prefix="$"
                type="number"
                onKeyPress={(e: any) =>
                  !validateCharges(e) && e.preventDefault()
                }
                onKeyDown={(evt) =>
                  (evt.key === "e" || evt.key === "+" || evt.key === "-") &&
                  evt.preventDefault()
                }
              />
            </FloatLabel>

            <FloatLabel
              label="Days/Units"
              name="units"
              form={form}
              rules={[
                { required: !isSubmitting, message: "Required" },
                () => ({
                  async validator(_: any, value: string) {
                    if (
                      value &&
                      (isNaN(parseInt(value)) || parseInt(value) <= 0)
                    ) {
                      return Promise.reject(
                        new Error("Value must be greater than zero.")
                      );
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
              star
            >
              <Input
                type="number"
                onKeyDown={(evt) =>
                  (evt.key === "e" ||
                    evt.key === "+" ||
                    evt.key === "-" ||
                    evt.key === ".") &&
                  evt.preventDefault()
                }
              />
            </FloatLabel>
          </div>

          <div className="col-lg-4 col-md-4">
            <FloatLabel
              label="Rendering Provider"
              name="renderingProvider"
              form={form}
              validateTrigger={["onBlur"]}
              hasFeedback
              rules={[
                () => ({
                  async validator(_: any, value: any) {
                    if (
                      isSubmitting ||
                      !value ||
                      (await validateRenderingNpi(value))
                    ) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        "This NPI is not valid for rendering provider. Please enter a valid Type 1 NPI."
                      )
                    );
                  },
                }),
                { required: !isSubmitting, message: "Required" },
              ]}
              star
            >
              <Input
                type="number"
                onKeyDown={(evt) =>
                  (evt.key === "e" ||
                    evt.key === "+" ||
                    evt.key === "-" ||
                    evt.key === ".") &&
                  evt.preventDefault()
                }
              />
            </FloatLabel>

            <div className="btn-wrapper">
              <Button
                type="primary"
                style={{ width: "100%" }}
                onClick={() => validateProcedure()}
              >
                Add
              </Button>
            </div>
          </div>

          <div className="col-lg-12 col-md-12 mt-3">
            <Title level={5}>
              Billing Provider Information{" "}
              <span style={{ fontSize: "11px" }}>(box 33)</span>
            </Title>
            <div className="row flex-lg-wrap justify-content-start mb-3">
              <div className="col-lg-24 col-md-24">
                <FloatLabel
                  label="Vendor ID"
                  name="vendor"
                  form={form}
                  required
                >
                  <Select
                    onSelect={handleSelectVendor}
                    loading={props.isFetchingVendors}
                  >
                    {vendors.map((value: any) => (
                      <Option
                        key={value.RmiVendorId}
                        value={JSON.stringify(value)}
                      >
                        {value.RmiVendorId}
                      </Option>
                    ))}
                  </Select>
                </FloatLabel>
              </div>

              <div className="col-lg-24 col-md-24">
                <FloatLabel
                  label="NPI"
                  name="vendorNPI"
                  form={form}
                  shouldUpdate
                  validateTrigger={["onBlur"]}
                  dependencies={["facilityNPI"]}
                  hasFeedback
                  validateStatus={sameNPI ? "warning" : undefined}
                  help={
                    sameNPI
                      ? "Are you sure? Facility NPI should NOT be the same as the billing provider's NPI. Please revise your entry."
                      : undefined
                  }
                  rules={[
                    ({ getFieldValue }) => ({
                      async validator(_: any, value: any) {
                        if (
                          value !== "" &&
                          value === getFieldValue("facilityNPI")
                        ) {
                          setSameNPI(true);
                          return;
                        }

                        if (!value || (await verifyNPI(value))) {
                          setSameNPI(false);
                          return Promise.resolve();
                        }

                        setSameNPI(false);
                        return Promise.reject(
                          new Error(
                            "This NPI does not exist on our system. Please revise your entry."
                          )
                        );
                      },
                    }),
                  ]}
                  required
                  float
                >
                  <Input placeholder="Enter NPI..." />
                </FloatLabel>
              </div>

              <div className="col-lg-24 col-md-24">
                <FloatLabel
                  label="Name"
                  name="vendorName"
                  form={form}
                  required
                  float
                >
                  <Input />
                </FloatLabel>
              </div>

              <div className="col-lg-24 col-md-24">
                <FloatLabel
                  label="Address"
                  name="vendorAddress"
                  form={form}
                  required
                  float
                  validateTrigger={["onBlur", "onChange"]}
                >
                  <Input />
                </FloatLabel>
              </div>

              <div className="col-lg-12 col-md-12">
                <FloatLabel
                  label="City"
                  name="vendorCity"
                  form={form}
                  required
                  float
                >
                  <Input />
                </FloatLabel>
              </div>

              <div className="col-lg-4 col-md-4">
                <FloatLabel
                  label="State"
                  name="vendorState"
                  form={form}
                  required
                  float
                  rules={[
                    () => ({
                      async validator(_: any, value: string) {
                        if (!value || states.includes(value.toUpperCase())) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error("Invalid State"));
                      },
                    }),
                  ]}
                >
                  <Input />
                </FloatLabel>
              </div>

              <div className="col-lg-8 col-md-8">
                <FloatLabel
                  label="Zip"
                  name="vendorZip"
                  form={form}
                  required
                  float
                  rules={[
                    () => ({
                      async validator(_: any, value: string) {
                        if (!value || value.match(/^\d{5}(-?\d{4})?(?!-)$/)) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error("Invalid Zip Code"));
                      },
                    }),
                  ]}
                >
                  <Input />
                </FloatLabel>
              </div>

              <div className="col-lg-24 col-md-24">
                <FloatLabel label="Phone" name="vendorPhone" form={form} float>
                  <Input type="tel" />
                </FloatLabel>
              </div>
            </div>
          </div>

          <div className="col-lg-12 col-md-12 mt-3">
            <Title level={5}>
              Facility Information{" "}
              <span style={{ fontSize: "11px" }}>(box 32)</span>
            </Title>
            <div className="row flex-lg-wrap justify-content-start mb-3">
              <div className="col-lg-24 col-md-24">
                {!posOffice && (
                  <Alert
                    message="Facility information is required when place of service (POS) is not an office (11), telehealth (02) or telehealth(10)."
                    type="error"
                  />
                )}

                <FloatLabel
                  label="NPI Type 2"
                  name="facilityNPI"
                  form={form}
                  required
                  dependencies={["vendorNPI"]}
                  validateTrigger={["onBlur", "onChange"]}
                  hasFeedback
                  validateStatus={sameNPI ? "warning" : undefined}
                  help={
                    sameNPI
                      ? "If services were performed at your normal office location, please leave blank. If performed outside your normal office location, please include the facility NPI (NPI Type 2)."
                      : undefined
                  }
                  rules={[
                    ({ getFieldValue }) => ({
                      async validator(_: any, value: any) {
                        if (
                          value !== "" &&
                          value === getFieldValue("vendorNPI")
                        ) {
                          setSameNPI(true);
                          return;
                        }

                        if (!value || (await verifyNPI(value))) {
                          setSameNPI(false);
                          return Promise.resolve();
                        }
                        setSameNPI(false);
                        return Promise.reject(
                          new Error(
                            "This NPI does not exist on our system. Please revise your entry."
                          )
                        );
                      },
                      validateTrigger: "onBlur",
                    }),
                  ]}
                >
                  <Input />
                </FloatLabel>
              </div>

              <div className="col-lg-24 col-md-24">
                <FloatLabel
                  label="Facility"
                  name="facility"
                  form={form}
                  value="Placeholder"
                  required
                >
                  <Select
                    placeholder="Select Facility"
                    onSelect={handleSelectFacility}
                    loading={props.isFetchingFacilities}
                    disabled={facilities.length === 0}
                  >
                    {facilities.map((facility) => (
                      <Option
                        key={facility.ProvKeyId}
                        value={JSON.stringify(facility)}
                      >
                        {facility.LastName}
                      </Option>
                    ))}
                  </Select>
                </FloatLabel>
              </div>

              <div className="col-lg-24 col-md-24">
                <FloatLabel
                  label="Enter Facility Name"
                  name="facilityName"
                  form={form}
                  required
                >
                  <Input />
                </FloatLabel>
              </div>

              <div className="col-lg-24 col-md-24">
                <FloatLabel
                  label="Address"
                  name="facilityAddress"
                  form={form}
                  required
                  rules={[
                    () => ({
                      async validator(_: any, value: string) {
                        if (
                          !value ||
                          !value.match(
                            /^ *((#\d+)|((box|bin)[-. \/\\]?\d+)|(.*p[ \.]? ?(o|0)[-. \/\\]? *-?((box|bin)|b|(#|n|num|number)?\d+))|(p(ost|ostal)? *(o(ff(ice)?)?)? *((box|bin)|b)? *(#|n|num|number)*\d+)|(p *-?\/?(o)? *-?box)|post office box|((box|bin)|b) *(#|n|num|number)? *\d+|(#|n|num|number) *\d+)/i
                          )
                        ) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error("Address cannot be a PO Box.")
                        );
                      },
                    }),
                  ]}
                  float
                >
                  <Input />
                </FloatLabel>
              </div>

              <div className="col-lg-12 col-md-12">
                <FloatLabel
                  label="City"
                  name="facilityCity"
                  form={form}
                  required
                  float
                >
                  <Input />
                </FloatLabel>
              </div>

              <div className="col-lg-4 col-md-4">
                <FloatLabel
                  label="State"
                  name="facilityState"
                  form={form}
                  required
                  rules={[
                    () => ({
                      async validator(_: any, value: string) {
                        if (!value || states.includes(value.toUpperCase())) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error("Invalid State"));
                      },
                    }),
                  ]}
                  float
                >
                  <Input />
                </FloatLabel>
              </div>

              <div className="col-lg-8 col-md-8">
                <FloatLabel
                  label="Zip"
                  name="facilityZip"
                  form={form}
                  required
                  rules={[
                    () => ({
                      async validator(_: any, value: string) {
                        if (!value || value.match(/^\d{5}(-?\d{4})?(?!-)$/)) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error("Invalid Zip Code"));
                      },
                    }),
                  ]}
                  float
                >
                  <Input />
                </FloatLabel>
              </div>
            </div>
          </div>
        </div>

        <p className="mt-3">
          Required Fields <span style={{ color: "red" }}>*</span>
        </p>
        <div className="col-lg-24 col-md-24 mt-2 mb-3">
          <DropzoneLocal
            fileList={attachmentList}
            setFileList={setAttachmentList}
          />
        </div>

        <div className="col-lg-24 col-md-24 mt-2">
          <div className="btn-wrapper">
            <Button
              type="primary"
              onClick={onSubmitAlert}
              loading={
                props.isFetchingCPTCodes ||
                props.isFetchingDiagCodes ||
                props.isFetchingModifierCodes ||
                props.isFetchingNPI ||
                props.isFetchingPOS ||
                props.isFetchingVendors ||
                props.isSavingHedisClaim ||
                props.isFetchingNdcCodes
              }
              style={{ width: "100%" }}
              disabled={missingCPTCode}
            >
              Submit
            </Button>
          </div>

          {showClaimSubmitted && (
            <Alert
              style={{ textAlign: "center" }}
              message="Success!"
              description="Claim request has been submitted."
              type="success"
            />
          )}

          {missingCPTCode && (
            <Alert
              style={{ textAlign: "center" }}
              message="All CPT codes must be filled."
              type="error"
            />
          )}
        </div>
      </div>
    </Form>
  );
};

const mapStateToProps = (store: RootStateOrAny) => ({
  isCreating: store.rootReducer.claim.isCreating,
  isFetchingNPI: store.rootReducer.claimNPI.isFetching,
  isFetchingOther: store.rootReducer.claimNPI.isFetchingOther,
  isCheckingDME: store.rootReducer.claimNPI.isChecking,
  isFetchingVendors: store.rootReducer.app.isFetchingVendors,
  isFetchingModifierCodes: store.rootReducer.authModifierCode.isFetching,
  isFetchingPOS: store.rootReducer.authPOS.isFetching,
  isCheckingMediCalCode: store.rootReducer.authMediCal.isChecking,
  isSearching: store.rootReducer.claimCPTCodes.isSearching,
  isFetchingDiagCodes: store.rootReducer.authDiagCodes.isFetching,
  isFetchingCPTCodes: store.rootReducer.claimCPTCodes.isFetching,
  isValidatingRenderingNPI: store.rootReducer.claimNPI.isValidating,
  isVerifyingNPI: store.rootReducer.claimNPI.isVerifying,
  isFetchingAuthDetail: store.rootReducer.claimMember.isFetchingAuth,
  isCheckingCompatibility: store.rootReducer.claimNDC.isChecking,
  isFetchingRelatedNdc: store.rootReducer.claimNDC.isFetching,
  isFetchingName: store.rootReducer.claimNPI.isFetchingName,
  isFetchingFacilities: store.rootReducer.authFacilities.isFetching,
  isUploading: store.rootReducer.claim.isUploading,
  isFetchingNdcCodes: store.rootReducer.claimNDC.isFetching,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      create,
      getProviderNPI,
      getOther,
      checkIsDME,
      getVendors,
      getAuthModifierCode,
      getPos,
      checkMediCalCode,
      searchByType,
      getDiagCodes,
      getCPTCodes,
      validateRendering,
      verify,
      getAuthDetail,
      checkCPTCompatibility,
      getRelated,
      getNdcCodes,
      checkIfNdcIsRequired,
      getNameFromNpi,
      getFacilities,
      getClaimsFacilities,
      uploadAttachment,
      getInvalidPrimDxInitials,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ClaimInfo);
